import { Component, OnInit, ElementRef } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-stock-statement',
  templateUrl: './stock-statement.component.html',
  styleUrls: ['./stock-statement.component.css']
})
export class StockStatementComponent implements OnInit {

  constructor(public ElementRef:ElementRef,private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }

  
  SearchItemModel = {
    ItemCategoryID: 0,
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
    ToDate: moment(new Date()).format('DD-MMM-YYYY'),
    ItemCode: '',
    ItemName: '',


}
StatementList = [];
RecordSearch = false;
Submitted = false;
ClearSearch () {
    this.SearchItemModel = {
        ItemCategoryID: 0,
        FromDate: moment(new Date()).format('DD-MMM-YYYY'),
        ToDate: moment(new Date()).format('DD-MMM-YYYY'),
        ItemCode: '',
        ItemName: '',
    }
    this.StatementList = [];
    this.RecordSearch = false;
    this.Submitted = false;
}

 ValidityState() {
    return this.SearchItemModel.FromDate == '' || this.SearchItemModel.ToDate == '' || this.SearchItemModel.ItemCategoryID == 0 || this.SearchItemModel.ItemCode == '' || this.SearchItemModel.ItemName == '';
}
PreviousBalance=0;
OpeningBalance=0;
TotalCredit = 0;
TotalDebit = 0;
GetAllStockStatement () {
    this.Submitted = true;  
    this.StatementList = [];
    if (!this.ValidityState()) {
        this.RecordSearch = true;
        this.SearchItemModel.FromDate=this.SearchItemModel.FromDate!=null && this.SearchItemModel.FromDate!=''?moment(this.SearchItemModel.FromDate).format('DD-MMM-YYYY'):'';
        this.SearchItemModel.ToDate=this.SearchItemModel.ToDate!=null && this.SearchItemModel.ToDate!=''?moment(this.SearchItemModel.ToDate).format('DD-MMM-YYYY'):'';
       this.spinnerService.show();
        this.stockService.GetAllStockStatement(JSON.stringify(this.SearchItemModel)).subscribe( (data)=> {
        this.Submitted = false;
        this.spinnerService.hide();
        this.StatementList = data.StatementList;
        if (this.StatementList != null && this.StatementList.length>0) {
            this.RecordSearch = false;

            // Openning

            this.PreviousBalance = this.StatementList[0].OpeningBalance;
            this.OpeningBalance = this.StatementList[0].OpeningBalance;
            var TotalCredit=0;
            var TotalDebit=0;
            for (var i = 0; i < this.StatementList.length; i++) {                   
               
                TotalCredit=TotalCredit+this.StatementList[i].Credit;
                TotalDebit=TotalDebit+this.StatementList[i].Debit;

                if (this.PreviousBalance >= 0) {
                    this.PreviousBalance = this.PreviousBalance - this.StatementList[i].Debit + this.StatementList[i].Credit;
                }
                else {
                    this.PreviousBalance = this.PreviousBalance - this.StatementList[i].Debit + this.StatementList[i].Credit;
                }
                   
                this.StatementList[i].OpeningBalance = this.PreviousBalance;
                
               
            }
            this.TotalCredit = TotalCredit;
            this.TotalDebit = TotalDebit;
            if (this.OpeningBalance > 0) {
                this.TotalOpeningAmt = this.OpeningBalance + TotalDebit - TotalCredit;
            }
            else {
                this.TotalOpeningAmt = this.OpeningBalance - TotalDebit + TotalCredit;
            }

           
        }
        
    });
}
};
TotalOpeningAmt=0;


ItemCategoryList:any;
GetItemCategory () {
    var item = {
        ItemId: 2
    }
   
    this.lookupService.GetLookupsList('StockInventoryItemCategory', JSON.stringify(item)).subscribe( (response)=> {
        this.ItemCategoryList = response.LookupItems;
       
    });
};

INVItemList:any;
GetAllItemName () {
    this.INVItemList = [];
    this.SearchItemModel.ItemCode = '';
    this.SearchItemModel.ItemName = '';
    var itembi = {
        ItemId: this.SearchItemModel.ItemCategoryID,
        ItemCode1: "",
    }
   this.lookupService.GetLookupsList('StockItemName', JSON.stringify(itembi)).subscribe( (data)=> {
        this.INVItemList = data.LookupItems;
        this.INVItemList.splice(0, 1);
       
    });
    return this.INVItemList;
};
GetAllItemCode (m) {
    this.INVItemList = [];
    this.SearchItemModel.ItemCode = '';
    this.SearchItemModel.ItemName = '';
    var itembi = {
        ItemId: this.SearchItemModel.ItemCategoryID,
        ItemCode1: m,
    }
   this.lookupService.GetLookupsList('StockItemCode', JSON.stringify(itembi)).subscribe( (data)=> {
        this.INVItemList = data.LookupItems;
        this.INVItemList.splice(0, 1);
       
    });
    return this.INVItemList;
};

SelectedItemCode ($item) {
    this.SearchItemModel.ItemCode = $item.ItemCode1;
    this.SearchItemModel.ItemName = $item.ItemName;
}


// Download


GetDownloadList () {      
  
    this.Submitted = true;
    if (!this.ValidityState()) {
        
        this.JSONToCsvConverterList(this.StatementList, 'Stock_Statement_List_', true);
    }
  
};

 JSONToCsvConverterList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
        var row = "";
        row += 'Sr. No.' + ',';
        row += 'Item Code' + ',';
        row += 'Item Name' + ',';
        row += 'Date' + ',';
        row += 'Reference No.' + ',';
        row += 'Debit' + ',';
        row += 'Credit' + ',';
        row += 'Balance' + ',';
        row = row.slice(0, -1);
        CSV += row + '\r\n';
    }

    var row0 = "";
    row0 += '"' + '' + '",';
    row0 += '"' + '' + '",';
    row0 += '"' + '' + '",';
    row0 += '"' + '' + '",';
    row0 += '"' + 'Openning Balance' + '",';
    if (this.OpeningBalance < 0) {
    row0 += '"' + this.globalHelper.Decimal(this.OpeningBalance*-1) + '",';
    }
    else {
        row0 += '"' + '0.000' + '",';
    }
    if (this.OpeningBalance > 0) {
        row0 += '"' + this.globalHelper.Decimal(this.OpeningBalance) + '",';
    }
    else {
        row0 += '"' + '0.000' + '",';
    }
    if (this.OpeningBalance < 0) {
        row0 += '"' + this.globalHelper.Decimal(this.OpeningBalance * -1) +'Dr'+ '",';
    }
    else if (this.OpeningBalance > 0) {
        row0 += '"' + this.globalHelper.Decimal(this.OpeningBalance) + 'Cr'+ '",';
    }
    else {
        row0 += '"' + '0.000' + '",';
    }
    CSV += row0 + '\r\n';
    for (var i = 0; i < arrayData.length; i++) {
        var sno = i + 1;
        var row = "";
        row += '"' + sno + '",';
        if (arrayData[i].ItemCode != null) {
            row += '"' + arrayData[i].ItemCode + '",';
        }
        else {
            row += '"' + '' + '",';
        }

        if (arrayData[i].ItemName != null) {
            row += '"' + arrayData[i].ItemName + '",';
        }
        else {
            row += '"' + '' + '",';
        }

        if (arrayData[i].CreatedOn != null) {
            row += '"' + moment(new Date(arrayData[i].CreatedOn)).format('DD-MMM-YYYY') + '",';
        }
        else {
            row += '"' + '' + '",';
        }

        if (arrayData[i].ReferenceNo != null) {
            row += '"' + arrayData[i].ReferenceNo + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        
        if (arrayData[i].Debit != null) {
            row += '"' + this.globalHelper.Decimal(arrayData[i].Debit) + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].Credit != null) {
            row += '"' + this.globalHelper.Decimal(arrayData[i].Credit) + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].OpeningBalance < 0) {
            row += '"' + this.globalHelper.Decimal(arrayData[i].OpeningBalance * -1) + 'Dr' + '",';
        }
        else {
            row += '"' + this.globalHelper.Decimal(arrayData[i].OpeningBalance) + 'Cr' + '",';
        }
        row.slice(0, row.length - 1);
        CSV += row + '\r\n';
    }

    var row1 = "";
    row1 += '"' + '' + '",';
    row1 += '"' + '' + '",';
    row1 += '"' + '' + '",';
    row1 += '"' + '' + '",';
    row1 += '"' + 'Total' + '",';      
    row1 += '"' + this.globalHelper.Decimal(this.TotalDebit) + '",';
    row1 += '"' + this.globalHelper.Decimal(this.TotalCredit) + '",';
    if (this.TotalOpeningAmt < 0) {
        row1 += '"' + this.globalHelper.Decimal(this.TotalOpeningAmt * -1) + 'Dr' + '",';
    }
    else if (this.TotalOpeningAmt >= 0) {
        row1 += '"' + this.globalHelper.Decimal(this.TotalOpeningAmt) + 'Cr' + '",';
    }
   
    CSV += row1 + '\r\n';
    if (CSV == '') {
        alert('Invalid Data');
        return;
    }
    var FileName = ReportTitle + '_' + moment(new Date()).format('DD-MMM-YYYY');
    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
}

// Print

// GetPrintList () {
//     this.Submitted = true;
//     if (!this.ValidityState()) {
//         this.Submitted = false;   
              
//         var url = "../../../../App/Stock/StockStatement/StockStatementPrint.html?ReportType=PrintStatementList&ItemCategoryID=" + this.SearchItemModel.ItemCategoryID + "&ItemCode=" + this.SearchItemModel.ItemCode + "&ItemName=" + this.SearchItemModel.ItemName + "&FromDate=" + this.SearchItemModel.FromDate + "&ToDate=" + this.SearchItemModel.ToDate;
//         this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");          
       
//     }      
// };

  ngOnInit() {
    this.GetAllItemName();
    this.GetItemCategory();
  }

}
